export default {
  svgData: [
    {
      id: "slide1tv1",
      assets: [],
      name: "TV",
      label: "slide1tv1",
    },
    {
      id: "slide1easel1",
      assets: [
        "https://s3.us-east-2.amazonaws.com/cdn.scoutfeedback.com/gdot-workshop/sr316-bundle2/oconee/virgil-langford/virgil-langford-typical-section-page-1.jpg",
        "https://s3.us-east-2.amazonaws.com/cdn.scoutfeedback.com/gdot-workshop/sr316-bundle2/oconee/virgil-langford/virgil-langford-typical-section-page-2.jpg"
      ],
      name: "Easel1",
      label: "slide1easel1",
    },
    {
      id: "slide1easel2",
      url: "https://s3.us-east-2.amazonaws.com/cdn.scoutfeedback.com/gdot-workshop/sr316-bundle2/oconee/virgil-langford/virgil-langford-concept-display.pdf",
      name: "Easel2",
      label: "slide1easel2",
    },
    {
      id: "slide1display1",
      url: "https://s3.us-east-2.amazonaws.com/cdn.scoutfeedback.com/gdot-workshop/sr316-bundle2/oconee/virgil-langford/virgil-langford-project-handout.pdf",
      name: "Display1",
      label: "slide1display1",
    },
    {
      id: "slide1avatar1",
    },
    {
      id: "slide1bubble1",
    },
  ],
  slideTitle: "Virgil Langford",
  helpText: `
    <p class="text-justify help">The <strong>SR 8/SR 316/US 29 at </strong><strong>Virgil
    Langford Road (P.I. No. 0013768)</strong> is part of a series of roadway
    improvement projects along SR 316 from SR 20 in Gwinnett County to SR 10
    in Athens, Oconee County. The need for these projects is to upgrade
    sections of SR 316 to improve traffic flow and reduce the potential for
    crashes.</p>
    <p class="text-justify help">The SR 8/SR 316/US 29 Virgil Langford Road (P.I. No. 0013768)
    proposes the following:</p>
    <ul>
    <li><p class="text-justify help">Remove the existing at-grade, unsignalized intersection at CR
    440/CR 662/Virgil Langford Road.</p></li>
    <li><p class="text-justify help">Construct a grade separation at CR 440/CR 662/Virgil Lanford
    Road, removing direct access to and from SR 8/SR 316/US 29. The proposed
    new bridge would connect CR 440/CR 662/Virgil Langford Road across SR
    8/SR 316/US 29.</p></li>
    </ul>
    <ul>
    <li><blockquote>
    <p class="text-justify help"><strong><u>Project Handout</u></strong> – The handout on the
    table provides a summary of the proposed improvements, project details,
    and purpose of the project.</p>
    </blockquote></li>
    <li><blockquote>
    <p class="text-justify help"><strong><u>Concept Display/Roll Plot</u></strong> – The easel in
    the middle offers a detailed look of the project corridor. Refer to the
    Legend to help you navigate the concept display.</p>
    </blockquote></li>
    <li><blockquote>
    <p class="text-justify help"><strong><u>Project Visualization</u></strong> – The animated
    rendering provides a 3D aerial perspective of the projects.</p>
    </blockquote></li>
    <li><blockquote>
    <p class="text-justify help"><strong><u>Typical Section</u></strong> – The easel at the end
    showcases the various cross sections, or typical sections, based on the
    current project design. These sections represent the roadway and major
    elements that are the basis for construction.</p>
    </blockquote></li>
    </ul>
    <p class="text-justify help">Once your tour of the Project Design station is complete, we invite you to visit the next station by clicking on the right arrow 
    or selecting your station of choice from the navigation sidebar on the right. For additional information, click the following button <i class="mdi mdi-account-question" style="font-size:2em;"></i>   
    to learn about the specific station or the <i class="mdi mdi-information-outline" style="font-size:2em;"></i>to see this message again after you close it out. To return to the project website, 
    select the <i class="mdi mdi-exit-to-app" style="font-size:2em;"></i>icon.
    </p>
    `,
  aboutText: `
      <p class="text-justify help">In this space, we hope to help you better understand and
      visualize the project design for the <strong>SR 8/SR 316/US 29 at Virgil
      Langford Road (P.I. No. 0013768).</strong> The purpose of this project
      is to improve connectivity and mobility for motorists, and that this
      project will result in improved traffic conditions.</p>
      <p class="text-justify help">The Handout provides a detailed overview of the proposed
      improvements. The Concept Display, or roll plots, and Project
      Visualization offers an aerial view of the project limits and proposed
      improvements. The Typical Sections provide a visual representation of
      the various cross sections of roadway and major elements that are needed
      for construction.</p>
      <p class="text-justify help">Once your tour of the Project Design space is complete, we invite
      you to visit the next station by clicking on the right arrow or
      selecting your station of choice from the sidebar on the right.</p>
    `,
};
